export interface User {
  username: string;
  name: string;
  roles: string[];
  email: string;
  managedMultistockIds: string[];
  managedCompanyIds: string[];
  managedCompanyQuery?: string;
  managedAssortmentIds: string[];
  assortment: string;
  password: string;
  activeGroups: { [s: string]: any };
  phone: string;
  extra?: { [s: string]: any };
  managedSupplierIds?: string[];
  managedSupplierQuery?: any;
  authenticationMethod?: string;
  active?: boolean;
  forceChangePassword?: boolean;
  mfaOptions?: MfaOption[];
}

export interface MfaOption {
  type: 'TOTP';
  id: string;
  createdAt: string;
  deviceName: string;
  enabled: boolean;
  status: 'VERIFIED' | 'PENDING_VERIFICATION';
}

export interface AuthState {
  user?: User;
  badLogin: boolean;
  authenticated: boolean;
  internalServerError: boolean;
  userDisabled: boolean;
  userForceChangePassword: boolean;
  mfaRequired: boolean;
  mfaState: 'setup' | 'code' | null;
}

export const featureName = 'auth';
